type GalleryImages = {
  url: string;
  size: number;
};

export const handleSortGalleryImagesByUrl = (imageUrls: GalleryImages[]) => {
  return imageUrls.sort((a: any, b: any) => {
    // A
    const urlPartsA = a.url.split('/');

    const filenameWithQueryA = urlPartsA[urlPartsA.length - 1];

    const filenameA = filenameWithQueryA.split('?')[0];

    // B;
    const urlPartsB = b.url.split('/');

    const filenameWithQueryB = urlPartsB[urlPartsB.length - 1];

    const filenameB = filenameWithQueryB.split('?')[0];

    // Compare the file names
    return filenameA.localeCompare(filenameB);
  });
};
